<template>
  <el-menu
  default-active="1"
  @open="handleOpen"
  @close="handleClose"
  background-color="#324053"
  text-color="#fff"
  active-text-color="#ffd04b"
  mode="horizontal">
    <el-menu-item index="1">
      <span slot="title">新闻动态</span>
    </el-menu-item>
    <el-menu-item index="2">
      <span slot="title">关于我们</span>
    </el-menu-item>
    <el-menu-item index="3">
      <span slot="title">加入我们</span>
    </el-menu-item>
    <el-menu-item index="4">
      <span slot="title">联系我们</span>
    </el-menu-item>
    <el-menu-item index="5">
      <span slot="title">用户</span>
    </el-menu-item>
    <el-menu-item index="6">
      <span slot="title">系统</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
  export default {
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  }
</script>

<style scoped>
.el-menu {
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/views/server_web/layout/nav.vue